/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { campaignAction } from "@redux/modules";
import moment from "moment";
import { NavLink, useParams } from "react-router-dom";

// Header - Footer
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";

/**
 * Kampanya detayı — /magazine detayıyla aynı tasarım. Kampanya, kullanıcı
 * listesinden (USER) id ile bulunur; doğrudan girişte liste yeniden çekilir.
 */
const CampaignDetail = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [filteredCampaign, setFilteredCampaign] = useState(null);

  const campaignList = useSelector((store) => store.campaign.campaignList);

  useEffect(() => {
    dispatch(campaignAction.getUserCampaignList());
    return () => {};
  }, [dispatch]);

  useEffect(() => {
    if (Array.isArray(campaignList) && campaignList.length > 0) {
      const campaign = campaignList.find(
        (item) => item.id === parseInt(id, 10)
      );
      if (campaign) {
        setFilteredCampaign(campaign);
      }
    }
  }, [campaignList, id]);

  const formatRange = (item) => {
    if (!item) return "";
    const begin = item.dateBegin
      ? moment(item.dateBegin).format("DD.MM.YYYY")
      : "";
    const end = item.dateEnd ? moment(item.dateEnd).format("DD.MM.YYYY") : "";
    if (begin && end) return `${begin} - ${end}`;
    return begin || end;
  };

  return (
    <div className="page-container">
      <Header />

      <main>
        <section className="bg-blue pt-5 pb-5">
          <div className="container">
            <div
              className="d-lg-flex d-none text-white small mb-5 opacity-50"
              data-title-background
            >
              <NavLink
                to="/home"
                className="text-white text-decoration-none me-3"
              >
                Anasayfa
              </NavLink>
              <span className="me-3">»</span>
              <NavLink
                to="/campaigns"
                className="text-white text-decoration-none me-3"
              >
                Kampanyalarımız
              </NavLink>
              {filteredCampaign?.campaignPeriodName && (
                <>
                  <span className="me-3">»</span>
                  <a
                    href="javascript:void(0)"
                    className="text-white text-decoration-none"
                  >
                    {filteredCampaign.campaignPeriodName}
                  </a>
                </>
              )}
            </div>

            {filteredCampaign ? (
              <div
                className="row justify-content-center mb-5"
                data-title-background
              >
                <div className="col-xl-8 col-lg-10 text-center">
                  <h1 className="lh-base mb-4 text-white">
                    {filteredCampaign.name}
                  </h1>
                  {(formatRange(filteredCampaign) ||
                    filteredCampaign.campaignPeriodName) && (
                    <div className="opacity-50 small text-white">
                      <span>{formatRange(filteredCampaign)}</span>
                      {filteredCampaign.campaignPeriodName && (
                        <span className="ms-3">
                          #{filteredCampaign.campaignPeriodName}
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <p className="text-white">
                Kampanya bulunamadı ya da yükleniyor...
              </p>
            )}
          </div>
        </section>

        <section className="position-relative mb-sm-10 mb-5 mt-n5">
          <div className="container">
            {filteredCampaign ? (
              <div>
                <div className="row justify-content-center mb-sm-8 mb-5">
                  <div className="col-xl-10">
                    <div className="overflow-hidden rounded-3">
                      {filteredCampaign?.contentList?.length > 0 ? (
                        <img
                          src={filteredCampaign.contentList[0]}
                          alt={filteredCampaign.name}
                          className="img-cover w-100"
                        />
                      ) : (
                        <div style={{ background: "#ddd", height: "390px" }} />
                      )}
                    </div>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-xl-8 col-lg-10 content">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: filteredCampaign.content,
                      }}
                    ></p>
                  </div>
                </div>
              </div>
            ) : (
              <p>Kampanya bulunamadı ya da yükleniyor...</p>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default CampaignDetail;
